const createDrawerAnimation = (duration, prop, inAnimation, outAnimation) => ({
    enter: {
        property: {
            name: prop,
            value: outAnimation,
        },
    },
    enterActive: {
        property: {
            name: prop,
            value: inAnimation,
        },
        transition: {
            duration,
            timing: 'ease',
        },
    },
    exit: {
        property: {
            name: prop,
            value: inAnimation,
        },
    },
    exitActive: {
        property: {
            name: prop,
            value: outAnimation,
        },
        transition: {
            duration,
            timing: 'ease-out',
        },
    },
});
const DrawerSlideInLeft = 'translateX(0)';
const DrawerSlideOutLeft = 'translateX(-100%)';
const DrawerSlideLeftAnimation = (duration) => createDrawerAnimation(duration, 'transform', DrawerSlideInLeft, DrawerSlideOutLeft);
const DrawerSlideInRight = 'translateX(0)';
const DrawerSlideOutRight = 'translateX(100%)';
const DrawerSlideRightAnimation = (duration) => createDrawerAnimation(duration, 'transform', DrawerSlideInRight, DrawerSlideOutRight);
const DrawerSlideInTop = 'translateY(0)';
const DrawerSlideOutTop = 'translateY(-100%)';
const DrawerSlideTopAnimation = (duration) => createDrawerAnimation(duration, 'transform', DrawerSlideInTop, DrawerSlideOutTop);
const DrawerSlideInBottom = 'translateY(0)';
const DrawerSlideOutBottom = 'translateY(100%)';
const DrawerSlideBottomAnimation = (duration) => createDrawerAnimation(duration, 'transform', DrawerSlideInBottom, DrawerSlideOutBottom);

export { DrawerSlideBottomAnimation, DrawerSlideInBottom, DrawerSlideInLeft, DrawerSlideInRight, DrawerSlideInTop, DrawerSlideLeftAnimation, DrawerSlideOutBottom, DrawerSlideOutLeft, DrawerSlideOutRight, DrawerSlideOutTop, DrawerSlideRightAnimation, DrawerSlideTopAnimation };
//# sourceMappingURL=DrawerSlide.js.map
